import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  serverUrl: String = environment.serverUrl;
  constructor(private httpClient: HttpClient) { }

  listallDeletedUsers_within_App(
    id: any,
    pageNumber: number = 1,
    pageSize: number = 0,
    sortField = null,
    sortType = null,
    searchText = null,
    searchField = null,
    startDate = null,
    endDate = null
  ) {
    if (!searchText) searchText = "";
    return this.httpClient.get(
      this.serverUrl + `v2/in-site/client/${id}/users/reports/deleted-users`,
      {
        params: new HttpParams()
          .set("pageNumber", pageNumber.toString())
          .set("pageSize", pageSize.toString())
          .set("sortField", sortField)
          .set("sortType", sortType)
          .set("searchText", searchText)
          .set("searchField", searchField)
          .set("startDate", startDate)
          .set("endDate", endDate)
      }
    );
  }
  getUserLogs(clientId, appId: String = null, roleId: String = null, roleName = null, activity, pageIndex, pageSize, status, startDate, endDate, userName, viewLatest,sortField,sortDirection) {
    return this.httpClient.get(`${this.serverUrl}v2/in-site/client/${clientId}/users/reports/user-reports/${appId}/${roleId}`, {
      params: new HttpParams()
        .set("pageIndex", pageIndex)
        .set("pageSize", pageSize)
        .set("status", status)
        .set("startDate", startDate)
        .set("endDate", endDate)
        .set("userName", userName)
        .set("viewLatest", viewLatest)
        .set("activity", activity)
        .set("roleName", roleName)
        .set("sortField", sortField)
        .set("sortDirection", sortDirection)
    });
  }
  listRolesOfClientForApplication(applicationid: any, clientId: any) {
    return this.httpClient.get(
      `${this.serverUrl}auth/client-app-roles/${clientId}/${applicationid}`
    );
  }
}

